var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var vein = require('veinjs');

require('jquery-ui/datepicker');

// Disable auto-positioning datepicker above button on small screens
$.extend($.datepicker, {
	_checkOffset: function(inst, offset, isFixed) {
		return offset;
	}
});

function CalendarFilters(el) {
	this.$el = $(el);

	this.$body = $('body');
	this.$tags = this.$el.find('.calendar-filters__tag');
	this.$form = this.$el.find('form');
	this.$tier1 = this.$el.find('[data-tier="1"]');
	this.$tier2 = this.$el.find('[data-tier="2"]');
	this.filters = {
		'tier1': 'all',
		'tier2': []
	};

	var $dateInput = $('.calendar-filters__select-date input[name="date"]');

	this.disableFilters($('[data-category]'));

	$dateInput.datepicker({
		prevText: '',
		nextText: '',
		dateFormat: 'yy-mm-dd',
		defaultDate: $dateInput.val(),
		firstDay: 1,
		showAnim: '',
		beforeShow: function(inputEl, instance) {
			var offset = (inputEl.offsetWidth * 0.5) - 140;

			if(window.innerWidth < 850) {
				offset = inputEl.offsetWidth - 140;
			}

			instance.dpDiv.css({
				'transform': 'translateX('+offset+'px)'
			});

			$(this).closest('form').addClass('datepicker-showing');

			$.datepicker._pos = null;
		},
		onClose: function() {
			$(this).closest('form').removeClass('datepicker-showing');
		},
		onSelect: function(dateText) {
			window.location = $(this).closest('form').attr('action')+'?date='+dateText;
		}
	});

	$dateInput.closest('form').on('click', function(event) {
		event.preventDefault();
		$(this).find('input[name="date"]').datepicker('show');
	});

	$('[data-toggle="explore"]').on('click', function() {
		this.$body.toggleClass('calendar-filters-open');
	}.bind(this));


	this.$form.on('change', 'input', function(e) {
		var $current = $(e.target),
			$tag;

		if (parseInt($current.data('tier')) === 1) {
			this.filters.tier1 = $current.val();
		} else {
			$tag = $current.closest('label');
			$tag.toggleClass('js-tag-select');
			this.filters.tier2 = [];
			this.$tier2.filter(':checked').each(function(i, checkbox) {
				this.filters.tier2.push(checkbox.value);
			}.bind(this));
		}

		this.filter();
	}.bind(this));

    // Resetting radios to unchecked when resetting filters
    $('[data-reset]').on('click', function(e) {
        e.preventDefault();
        this.$body.removeClass('calendar-filtered');
        $('.calendar-week__mobile-date, .calendar-week__mobile').removeClass('filtered-out');
        $('.js-tag-select').removeClass('js-tag-select');

        this.$tier1.filter('[value="all"]').prop('checked', true);
        this.$tier2.prop('checked', false);

        this.filters.tier1 = 'all';
        this.filters.tier2 = [];

        this.filter();
    }.bind(this));
}

CalendarFilters.prototype.filter = function() {
	var $matched = $([]),
		$matchedTier1 = $('[data-category]');

	$matchedTier1.removeClass('js-is-selected');

	if ( this.filters.tier1 === 'all' && this.filters.tier2.length === 0) {
		this.$body.removeClass('calendar-filtered');
		this.disableFilters($matchedTier1);
		return;
	} else {
		this.$body.addClass('calendar-filtered');
	}

	if (this.filters.tier1 !== 'all') {
		$matchedTier1 = $matchedTier1.filter('[data-category*="' + this.filters.tier1 + '"]');
	}

	if (this.filters.tier2.length === 0) {
		$matched = $matchedTier1;
	} else {
		$.each(this.filters.tier2, function(i, selectedCategory) {
			$matched = $matched.add($matchedTier1.filter('[data-category*="' + selectedCategory + '"]'));
		});
	}

	$matched.addClass('js-is-selected');
	this.disableFilters($matched);
	this.filterOutMobile($matched);
};

CalendarFilters.prototype.filterOutMobile = function($collection) {
	$('.calendar-week__mobile').addClass('filtered-out');
	$('.calendar-week__mobile-date').addClass('filtered-out');

	$collection.each(function(i, element) {
		var $element = $(element),
			$prev = $element;

		$element.closest('.calendar-week__mobile').removeClass('filtered-out');

		do {
			$prev = $prev.prev();
		} while ($prev.length !== 0 && ! $prev.hasClass('calendar-week__mobile-date'));

		$prev.removeClass('filtered-out');
	});
};

CalendarFilters.prototype.disableFilters = function($collection) {
	this.$tags.addClass('js-is-disabled');
	this.$tier2.prop('disabled', true);
	
	$collection.each(function(i, element) {
		var $element = $(element),
			categories = $element.data('category').split(',');

		for (var j = 0; j < categories.length; j++) {
			$('input[data-tier="2"][value="' + categories[j] + '"]').prop('disabled', false).closest('.calendar-filters__tag').removeClass('js-is-disabled');
		}
	});
};

module.exports = CalendarFilters;
